import { FileModel } from '../models/fileModel';

export class EmailDataModel {
    public to: string;
    public from: string;
    public replyTo: string;
    public subject: string;
    public plainText: string;
    public htmlText: string;
    public toName: string;
    public offerNumber: string;
    public attachments: Array<FileModel>;
}